<template>
  <h1>
    <slot />
  </h1>
</template>

<script>
export default {
  props: {},
};
</script>

<style scoped>
h1 {
  margin-top: 0;
  margin-bottom: 0;

  color: var(--gray-800);

  font-size: 48px;
  font-family: var(--font-family-serif);
  font-weight: 600;
  line-height: 52px;
  text-align: left !important; /* NOTE @chris Global leak. */
}

@media (max-width: 960px) {
  h1 {
    font-size: 40px;
    line-height: 48px;
  }
}
</style>
